export default __webpack_public_path__ + "resources/icons/d422-c2e8.png";